import React, { useEffect, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { registerResource, resolveResource } from '../../store/screenSlice'


function ImageBody({
    isNeedRegisterResource,
    src,
    className,
    alt,
    style,
    onClick,
    onMouseDown,
    registerResource,
    resolveResource,
    draggable,
    droppable,
}) {
    const imgRef = useRef(null)

    useEffect(() => {
        if (isNeedRegisterResource) {
            registerResource(src)
        }
    }, [isNeedRegisterResource, registerResource, src])

    const resolveResourceHandler = useCallback(() => {
        if (isNeedRegisterResource) {
            resolveResource(src)
        }
    }, [isNeedRegisterResource, resolveResource, src])

    useEffect(() => {
        if (imgRef.current.complete) {
            resolveResourceHandler(src)
        }
    }, [resolveResourceHandler, src])

    return (
        <img
            ref={imgRef}
            src={src}
            className={className}
            alt={alt}
            onClick={onClick}
            onMouseDown={onMouseDown}
            aria-hidden
            onLoad={resolveResourceHandler}
            onError={resolveResourceHandler}
            draggable="false"
            style={style}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(draggable ? ({ 'data-draggable': draggable }) : {})}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(droppable ? ({ 'data-droppable': droppable }) : {})}
        />
    )
}

ImageBody.propTypes = {
    isNeedRegisterResource: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
    alt: PropTypes.string,
    draggable: PropTypes.any,
    droppable: PropTypes.any,
    style: PropTypes.any,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    registerResource: PropTypes.func.isRequired,
    resolveResource: PropTypes.func.isRequired,
}

const Image = connect(
    null, {
        registerResource,
        resolveResource,
    },
)(ImageBody)

Image.propTypes = {
    isNeedRegisterResource: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
    alt: PropTypes.string,
    draggable: PropTypes.any,
    droppable: PropTypes.any,
    style: PropTypes.any,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
}

Image.defaultProps = {
    isNeedRegisterResource: true,
}

export { Image }
